import { useQuery, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';
import { deserializeCdn } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/serializer';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { cdnKeys } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/keys';

function fetchCDNs({
  schoolyearId,
  schoolId,
  notationsSystems,
}: {
  schoolyearId: string;
  schoolId: string;
  notationsSystems: { [key: string]: NotationSystem };
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/carnets-de-notes`;
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: any[] }) =>
    (data || []).map(cdn => deserializeCdn(cdn, notationsSystems)),
  );
}

export function useCarnetsDeNotes() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();
  const user = useUser();
  return useQuery({
    queryKey: cdnKeys.cdnList(schoolyear.id, school.id),
    queryFn: () =>
      fetchCDNs({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        notationsSystems: user.notationSystems,
      }).then(cdns => {
        cdns.forEach(cdn => {
          queryClient.setQueryData(
            cdnKeys.cdnDetail(schoolyear.id, school.id, cdn.id),
            cdn,
          );
        });
        return cdns;
      }),
    refetchOnWindowFocus: false,
  });
}
